import { render, staticRenderFns } from "./BannerProductCategoryItem.vue?vue&type=template&id=a48fa7da&scoped=true&"
import script from "./BannerProductCategoryItem.vue?vue&type=script&lang=js&"
export * from "./BannerProductCategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./BannerProductCategoryItem.vue?vue&type=style&index=0&id=a48fa7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48fa7da",
  null
  
)

export default component.exports